import {
  P360_FIRST_FYEAR,
  PLAN_REQUEST_FOR_PREV_YEARS,
} from 'legacy/lut/components/widgets/public/partner360/planning/config'
import {
  selectActualsTypeWithDefault,
  selectPartnerAccess,
} from 'legacy/lut/features/partner360/configuration'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useGetPlanningQuery } from 'partner360/entities/planning'
import { IMdfActivity } from 'partner360/features/mdfActivities/model/types'

import {
  getKeyInitiativeMdfMetrics,
  IKeyInitiativeMdfScope,
} from '../../lib/getKeyInitiativeMdfMetrics'

interface IUseKeyInitiativeMdfMetrics extends Omit<IKeyInitiativeMdfScope, 'actualsType'> {
  activities: IMdfActivity[]
}

export const useKeyInitiativeMdfMetrics = ({
  activities,
  partnerId,
  fYear,
  programType,
  period,
  businessUnit,
  focusArea,
}: IUseKeyInitiativeMdfMetrics) => {
  // Keep the same offering-context measure/default rule as the MDF Analysis Contra card.
  const actualsType = useSelector(selectActualsTypeWithDefault)
  const { isRegionalDistributor } = useSelector(selectPartnerAccess)
  const { currentData: planningData, isError } = useGetPlanningQuery(
    {
      partnerId,
      fYear,
      programType,
      fromFYear: Math.max(fYear - PLAN_REQUEST_FOR_PREV_YEARS, P360_FIRST_FYEAR),
      isRegionalDistributor,
    },
    { skip: !activities.length || !partnerId || !fYear || !programType || !period.length }
  )

  // Identical arguments reuse KI Editor's planningGzip cache; currentData prevents stale sales.
  return useMemo(
    () =>
      getKeyInitiativeMdfMetrics(activities, isError ? [] : (planningData?.Planning ?? []), {
        partnerId,
        fYear,
        programType,
        actualsType,
        period,
        businessUnit,
        focusArea,
      }),
    [
      activities,
      planningData?.Planning,
      isError,
      partnerId,
      fYear,
      programType,
      actualsType,
      period,
      businessUnit,
      focusArea,
    ]
  )
}
